import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../utils/rel';

class SubNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        subNavArea: PropTypes.array,
    };

    handleAreaArr = () => {
        try {
            const { subNavArea } = this.props;

            let prov = null;
            let city = null;

            if (typeof document !== 'undefined') {
                prov =
                    cookie.get('prov') && cookie.get('prov') !== '' && cookie.get('prov') !== 'cn010'
                        ? cookie.get('prov')
                        : null;
                city =
                    cookie.get('city') && cookie.get('city') !== '' && cookie.get('city') !== '010'
                        ? cookie.get('city')
                        : null;
            }

            if (prov && city) {
                let arr = subNavArea.filter(item => item.city === city);

                if (arr.length === 0) {
                    arr = subNavArea.filter(item => item.prov === prov).filter(item => item.prov === `cn${item.city}`);
                }

                if (arr.length > 0) {
                    return {
                        url: arr[0].url ? arr[0].url : '',
                        title: arr[0].title ? arr[0].title : '',
                    };
                }
            }

            return null;
        } catch (e) {
            console.error(e);

            return null;
        }
    };

    getInsteadIndex = content => {
        let index = 16;

        try {
            for (let i = 0; i < content.length; i++) {
                if (content[i] && content[i].title === '音乐') {
                    index = i;
                }
            }
        } catch (e) {
            console.error(e);

            return index;
        }

        return index;
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const len = content.length;
        const obj = this.handleAreaArr();
        const index = this.getInsteadIndex(content);

        if (obj && content.length > 0) {
            content.splice(index, 1, obj);
        }

        return (
            <div id="subNav" className={styles.sub_box}>
                <ul className={styles.sub_nav}>
                    {content.map((item, index) => (
                        <li key={index} style={{ width: `${99 / len}%` }}>
                            <a href={item.url} target="_blank" rel={rel} title={item.title}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(SubNav);
